(function () {
    'use strict';

    angular.module("imApp").factory("orderDialogService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1279,
                    parameters: parms || {}
                });
            },
            listDialogues: function (parms) {
                return $ihttp.post({
                    method: 1281,
                    parameters: parms || {}
                });
            },
            addMessage: function (edit) {
                return $ihttp.post({
                    method: 1280,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
